import { getMethod } from '../../common/api';

export const filterOwnListings = (query) => {
  return getMethod('/api/own-listings', query);
};
